import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { AppHeader } from 'components';

import RentalItemsList from 'pages/book-rental-items-list/components/rental-items-list/RentalItemsList'

import useStyles from './styles';

const BookRentalItemsList = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.root}>
      <AppHeader />

      <div className={classes.toolbar}>
        <Typography variant="h2" className={classes.toolbarTitle}>
          {t('Book Rental Items')}
        </Typography>
      </div>

      <div className={classes.listWrapper}>
        <RentalItemsList />
      </div>
    </div>
  );
};

export default BookRentalItemsList;
